// extracted by mini-css-extract-plugin
export var tags = "styles-module--tags--qymgH";
export var active = "styles-module--active--x+5Y1";